// extracted by mini-css-extract-plugin
export var readonly = "_hy-1";
export var star = "_hy-0";